<template>
  <div>
    <v-row class="flex-column text-center">
      <v-col>
        <v-icon size="100" color="primary">mdi-check-circle-outline</v-icon>
      </v-col>
      <v-col>
        <h3 class="display-36 primary--text">
          <span>{{ this.seekerData.SeekerName }},</span>
          {{ getString(stepContent, 'CVWizard_FifthStep_CVFileReady').Value }}
        </h3>
      </v-col>
      <v-col>
        <p
          class="display-24"
          v-html="
            getString(stepContent, 'CVWizard_FifthStep_WelcomeToSearch').Value
          "
        ></p>
      </v-col>
      <v-col>
        <v-btn
          color="primary"
          class="display-18"
          rounded
          min-width="150"
          @click="downloadCV"
          :loading="inProgress"
        >
          {{ getString(stepContent, 'CVWizard_FifthStep_Download').Value }}
        </v-btn>
        <p class="py-2">
          <nuxt-link :to="'/קורות-חיים/1/'">
            {{ getString(stepContent, 'CVWizard_FifthStep_Edit').Value }}
          </nuxt-link>
        </p>
      </v-col>
    </v-row>
    <v-row class="flex-column text-center">
      <v-col>
        <p>
          <strong class="d-block">
            {{ getString(stepContent, 'CVWizard_FifthStep_GoodLuck').Value }}
          </strong>
          {{ getString(stepContent, 'CVWizard_FifthStep_DrushimTeam').Value }}
        </p>
      </v-col>

      <v-col>
        <v-alert color="#e3e3e3">
          {{ getString(stepContent, 'CVWizard_FifthStep_CVFileToMail').Value }}
          <span class="primary--text">{{ this.seekerData.Email }}</span>
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CvStepsBase from '../base/CvStepsBase.vue';
import { fetchUserCV } from '@/lib/cvFiles.js';

export default {
  extends: CvStepsBase,
  components: {},

  data() {
    return {
      wizardStep: 5,
      otpDisplayTimeout: null,
      currentStep: 'fifthstep',
      seekerData: {
        SeekerName: '',
        Email: '',
        CVCode: 0,
      },
      seekerLoaded: false,
      inProgress: false,
    };
  },
  computed: {},
  mounted() {
    const currentStepNumber = this.$router.currentRoute.params.id;

    if (
      currentStepNumber == this.wizardStep &&
      !this.seekerLoaded &&
      this.isAvailable &&
      this.isLogged
    ) {
      let payload = { stepname: this.currentStep, data: null };

      this.$store
        .dispatch('updateStepperStatus', payload)
        .then(this.mapStoreData())
        .then(this.fetchUser())
        .then(this.activeOtp());
    }
  },
  methods: {
    activeOtp() {
      this.otpDisplayTimeout = setTimeout(() => {
        this.$nuxt.$emit('openOTP', 'default');
      }, 3000);
    },
    async downloadCV() {
      this.inProgress = true;
      const fileCode = this.seekerData.CVCode;
      await fetchUserCV(fileCode, this.$axios);
      this.inProgress = false;
    },

    async fetchUser() {
      await this.$auth.fetchUser();
    },

    mapStoreData() {
      try {
        if (this.stepData && !_.isEmpty(this.stepData)) {
          this.seekerData = this.stepData;
          this.seekerLoaded = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.otpDisplayTimeout);
  },
};
</script>
